import { IPublicClientApplication, AuthenticationResult } from "@azure/msal-browser";
import { setAuthType, setUser } from "../store/auth.duck";
import { microsoftRequest } from '@shared/services/EnvironmentVariables';
import { getStoreRef } from '@shared/services/storeRef';
import { TrackJS } from "trackjs";
import { rawUserRequest } from '@shared/services/Auth';
import { AuthType } from '@shared/auth/types';
import { getActiveGateway } from '@shared/auth/AuthGatewayProvider';
import { POPUP_SESSION_STORAGE_KEY } from '@shared/auth/authMachine.duck';

export { AuthType };

export function GetCurrentAuthType(): AuthType {
  return getStoreRef()?.getState().auth.authType as AuthType;
}

export function persistAuthType(authType: AuthType, dispatch?: any) {
  localStorage.setItem('type', authType);
  if (dispatch) {
    dispatch(setAuthType(authType));
  } else {
    getStoreRef()?.dispatch(setAuthType(authType));
  }
}

function _buildLoginRedirectRequest(instance: IPublicClientApplication, selectAccount: boolean): any {
  const requestConfig: any = { ...microsoftRequest.login };
  if (selectAccount ?? instance.getAllAccounts().length > 1) {
    requestConfig.prompt = 'select_account';
  } else if (instance.getAllAccounts().length === 1 && !instance.getActiveAccount()) {
    instance.setActiveAccount(instance.getAllAccounts()[0]);
  }
  return requestConfig;
}

export async function LoginWithRedirect(instance: IPublicClientApplication, dispatch: any, selectAccount: boolean, redirectUri?: string) {
  try {
    if (redirectUri) {
      localStorage.setItem('redirect', redirectUri)
    }

    const requestConfig = _buildLoginRedirectRequest(instance, selectAccount);
    await instance.acquireTokenRedirect(requestConfig);
  } catch (err: any) {
    TrackJS?.track(err.errorCode ? `LoginWithRedirect error: ${err.errorCode}` : err);
    window.location.href = `/login`;
  }
}

export async function HandleAuthenticationResult(_result: AuthenticationResult, dispatch: any, requestUser: boolean) {
  persistAuthType(AuthType.Microsoft, dispatch);

  if (requestUser) {
    const user = await rawUserRequest();
    dispatch(setUser(user));
  }
}

export function clearLoginStorage() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('idToken');
  localStorage.removeItem('authToken');
  localStorage.removeItem('tokenExpires');
  localStorage.removeItem('redirect');
  localStorage.removeItem('type');
  localStorage.removeItem(POPUP_SESSION_STORAGE_KEY);
  getActiveGateway()?.invalidate({ kind: 'all' });
}

export function resetAllLoginStorages() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('idToken');
  localStorage.removeItem('authToken');
  localStorage.removeItem('tokenExpires');
  localStorage.removeItem('redirect');
  localStorage.removeItem('type');
  localStorage.removeItem('attempt');
  localStorage.removeItem(POPUP_SESSION_STORAGE_KEY);
  getStoreRef()?.dispatch(setAuthType(null));
  getActiveGateway()?.invalidate({ kind: 'all' });
}
